export const SPECS = {
  CallCartV2FromCheckout: 'specs.ecom.CallCartV2FromCheckout',
  CartTooltipWithoutNumber: 'specs.stores.CartTooltipWithoutNumber',
  CartOOIThunderboltCSSOptimization: 'specs.stores.CartOOIThunderboltCSSOptimization',
  ShouldUseOpenSideCartApiInAddToCart: 'specs.stores.ShouldUseOpenSideCartApiInAddToCart',
  ShouldUseEcomPlatformPublicApiAddToCartInPP: 'specs.stores.ShouldUseEcomPlatformPublicApiAddToCartInPP',
  AddSlotToCartPage: 'specs.stores.AddSlotToCartPage',
  ExpressCheckoutInSideCart: 'specs.stores.ExpressCheckoutInSideCart',
  UseIsShippableInCartPage: 'specs.ecom.UseIsShippableInCartPage',
  ShowCssPerBreakpointIndicationsSideCart: 'specs.stores.ShowCssPerBreakpointIndicationsSideCart',
  SideCartElementsVisibilityInCss: 'specs.stores.SideCartElementsVisibilityInCss',
  MapCartSummaryColors: 'specs.stores.MapCartSummaryColors',
  GiftCardAddToCartSettings: 'specs.stores.ShowGiftCardAddToCartSettings',
  FixHandleCreateCheckoutError: 'specs.ecom.FixHandleCreateCheckoutError',
  DeliverySectionCheckoutUseDeliverySolutions: 'specs.stores.DeliverySectionCheckoutUseDeliverySolutions',
  FixCouponCss: 'specs.ecom.FixCouponCss',
  EmptyCartA11yFix: 'specs.ecom.EmptyCartA11yFix',
  SideCartEditor3SettingsPanel: 'specs.ecom.SideCartEditor3SettingsPanel',
  SideCartEditor3HideSettingsDesignPanel: 'specs.ecom.SideCartEditor3HideSettingsDesignPanel',
  MoveGetClientConfigToControllerFactory: 'specs.ecom.MoveGetClientConfigToControllerFactory',
  ExpressCheckoutButtonsSkeleton: 'specs.ecom.ExpressCheckoutButtonsSkeleton',
  PreloadOnCartCheckoutButton: 'specs.ecom.PreloadOnCartCheckoutButton',
  RemoveBackgroudColorCartItemThumbnail: 'specs.ecom.RemoveBackgroudColorCartItemThumbnail',
  MoveCartToViewerContext: 'specs.ecom.MoveCartToViewerContext',
  DontUseLineItemEnricherInCartAndCheckout: 'specs.ecom.DontUseLineItemEnricherInCartAndCheckout',
  FixSecureCheckoutBadgeColor: 'specs.ecom.FixSecureCheckoutBadgeColor',
  ExpressButtonsInternalLoaderInCart: 'specs.ecom.ExpressButtonsInternalLoaderInCart',
  MakeOnLoadWaitForLoaderToDisappearInExpress: 'specs.ecom.MakeOnLoadWaitForLoaderToDisappearInExpress',
  FixGoToCheckoutButtonFontWeight: 'specs.ecom.FixGoToCheckoutButtonFontWeight',
  OnlyCallDeliverySolutionsWhenNeededOnCart: 'specs.ecom.OnlyCallDeliverySolutionsWhenNeededOnCart',
  RefactorCouponOnCart: 'specs.ecom.RefactorCouponOnCart',
  RemovePickupPointSpecificTitleOnCart: 'specs.ecom.RemovePickupPointSpecificTitleOnCart',
  StopSendingOriginInCheckoutUrl: 'specs.ecom.StopSendingOriginInCheckoutUrl',
  UseEcommerceSettingsDeliveryCountries: 'specs.ecom.UseEcommerceSettingsDeliveryCountries',
  CallCartV2FromCartComponents: 'specs.ecom.CallCartV2FromCartComponents',
} as const;
